import { render, staticRenderFns } from "./Quizzes.vue?vue&type=template&id=324abcd6&scoped=true&"
import script from "./Quizzes.vue?vue&type=script&lang=js&"
export * from "./Quizzes.vue?vue&type=script&lang=js&"
import style0 from "./Quizzes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324abcd6",
  null
  
)

export default component.exports